import { useState, useEffect } from 'react'

export default function ReservationCountdown({ expiresAt, isReducedDuration = false }) {
  const [timeLeft, setTimeLeft] = useState(null)

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date()
      const expiry = new Date(expiresAt)
      const diff = expiry - now

      if (diff <= 0) {
        return { expired: true, hours: 0, minutes: 0 }
      }

      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

      return { expired: false, hours, minutes }
    }

    setTimeLeft(calculateTimeLeft())

    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 60000)

    return () => clearInterval(interval)
  }, [expiresAt])

  if (!timeLeft) {
    return null
  }

  if (timeLeft.expired) {
    return (
      <span className="badge badge-error font-semibold">
        EXPIRED
      </span>
    )
  }

  const isUrgent = timeLeft.hours < 24
  const isCritical = timeLeft.hours < 6

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className={`badge font-semibold ${
        isCritical ? 'badge-error animate-pulse' :
        isUrgent ? 'badge-warning' :
        'badge-success'
      }`}>
        {timeLeft.hours}h {timeLeft.minutes}m remaining
      </span>
      {isReducedDuration && (
        <span className="text-xs px-2 py-0.5 bg-amber-100 text-amber-700 rounded-full font-medium">
          48h hold
        </span>
      )}
    </div>
  )
}
